import React from "react"
import { useIntl } from "../hooks"
import { Testimonial } from "."
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import { IconArrow } from "../images"
import { routes } from "../helpers"

export default function WhatIsSocialie() {
  const { t } = useIntl()
  const data = useStaticQuery(graphql`
    fragment FileWhatIsSocialie on File {
      id
      childImageSharp {
        fluid(maxWidth: 1100) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    query {
      pbr: file(relativePath: { eq: "Logos/pbr.png" }) {
        ...FileWhatIsSocialie
      }
      wta: file(relativePath: { eq: "Logos/wta.png" }) {
        ...FileWhatIsSocialie
      }
      europeanTour: file(relativePath: { eq: "Logos/european-tour-new.png" }) {
        ...FileWhatIsSocialie
      }
      fiba: file(relativePath: { eq: "Logos/fiba.png" }) {
        ...FileWhatIsSocialie
      }
      ufc: file(relativePath: { eq: "Logos/ufc.png" }) {
        ...FileWhatIsSocialie
      }
      atpTour: file(relativePath: { eq: "Logos/atp.png" }) {
        ...FileWhatIsSocialie
      }
      multiplyOutreach: file(relativePath: { eq: "WhatIsSocialie/multiply-outreach.png" }) {
        ...FileWhatIsSocialie
      }
      doMore: file(relativePath: { eq: "WhatIsSocialie/do-more.png" }) {
        ...FileWhatIsSocialie
      }
      moreContent: file(relativePath: { eq: "WhatIsSocialie/more-content.png" }) {
        ...FileWhatIsSocialie
      }
      socialDream: file(relativePath: { eq: "WhatIsSocialie/social-dream.png" }) {
        ...FileWhatIsSocialie
      }
      growYourAudience: file(relativePath: { eq: "WhatIsSocialie/grow-your-audience.svg" }) {
        publicURL
      }
    }
  `)

  return (
    <>
      <div className="container tablet:mb-22.5 laptop:mb-19">
        <div className="mb-6 flex justify-center">
          <div className="laptop:max-w-10/12 text-center">
            <div className="mb-1.5">
              <h5 className="text-darkGrey text-h6 leading-h6 tracking-12 font-black">
                {t("Home__WhatIsSocialie--Subheading")}
              </h5>
            </div>
            <div className="mb-2.5">
              <h3 className="font-serif text-socialiePink text-h4 leading-h4">{t("Home__WhatIsSocialie--Heading")}</h3>
            </div>
            <div className="mb-3">
              <p className="text-body text-default">{t("Home__WhatIsSocialie--Desc")}</p>
            </div>
            <div className="flex justify-center">
              <Link to={routes.howItWorks} className="btn btn-outline group">
                <span className="flex items-center">
                  <p className="leading-p">{t("Global__HowItWorks")}</p>
                  <IconArrow className="ml-1 mt-1px w-2 h-2 transition-transform duration-100 ease-in-out transform group-hover:translate-x-0.5" />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="container -mb-10 laptop:-mb-0">
        <div className="flex flex-col items-center">
          <div className="mb-5.5 tablet:mb-10.5 laptop:mb-14.5 w-full flex flex-col laptop:flex-row justify-between">
            <div className="laptop:py-3.5 se:-mb-2 se:-ml-1/12 laptop:-ml-4.5% tablet:w-90 tablet:mx-auto w-140% laptop:w-7/12">
              <img src={data.growYourAudience.publicURL} alt="grow your audience" />
            </div>
            <Frame
              subheading={t("Home__WhatIsSocialie--SectionOne-Subheading")}
              heading={t("Home__WhatIsSocialie--SectionOne-Heading")}
              desc={t("Home__WhatIsSocialie--SectionOne-Desc")}
              quote={t("Home__TestimonialOne--Quote")}
              logoSrc={data.fiba.childImageSharp.fluid}
              author={t("Home__TestimonialOne--Author")}
              role={t("Home__TestimonialOne--Role")}
            />
          </div>
          <div className="mb-9.5 tablet:mb-13.5 laptop:mb-14.5 w-full flex flex-col-reverse laptop:flex-row justify-between">
            {/* Second WhatIsSocialie Section with Image */}
            <Frame
              subheading={t("Home__WhatIsSocialie--SectionTwo-Subheading")}
              heading={t("Home__WhatIsSocialie--SectionTwo-Heading")}
              desc={t("Home__WhatIsSocialie--SectionTwo-Desc")}
              logoSrc={data.atpTour.childImageSharp.fluid}
              quote={t("Home__TestimonialTwo--Quote")}
              author={t("Home__TestimonialTwo--Author")}
              role={t("Home__TestimonialTwo--Role")}
            />
            <div className="py-3.5 se:-mb-6 se:-ml-1/12 laptop:-mr-4.5% w-150% tablet:w-auto tablet:max-h-87.5 laptop:w-7/12">
              <Img fluid={data.moreContent.childImageSharp.fluid} alt="more content" />
            </div>
          </div>
          <div className="mb-6.5 tablet:mb-11.5 laptop:mb-14.5 w-full flex flex-col laptop:flex-row justify-between">
            {/* Third WhatIsSocialie Section with Image */}
            <div className="py-3.5 se:-mb-2 se:-ml-4/12 laptop:-ml-4.5% w-140% tablet:w-auto tablet:max-h-87.5 laptop:w-7/12">
              <Img fluid={data.doMore.childImageSharp.fluid} alt="do more" />
            </div>
            <Frame
              subheading={t("Home__WhatIsSocialie--SectionThree-Subheading")}
              heading={t("Home__WhatIsSocialie--SectionThree-Heading")}
              desc={t("Home__WhatIsSocialie--SectionThree-Desc")}
              logoSrc={data.wta.childImageSharp.fluid}
              author={t("Home__TestimonialThree--Author")}
              role={t("Home__TestimonialThree--Role")}
            />
          </div>
          <div className="mb-9 tablet:mb-10.5 laptop:mb-14.5 w-full flex flex-col-reverse laptop:flex-row justify-between">
            {/* Fourth WhatIsSocialie Section with Image */}
            <Frame
              subheading={t("Home__WhatIsSocialie--SectionFour-Subheading")}
              heading={t("Home__WhatIsSocialie--SectionFour-Heading")}
              desc={t("Home__WhatIsSocialie--SectionFour-Desc")}
              logoSrc={data.pbr.childImageSharp.fluid}
              quote={t("Home__TestimonialFour--Quote")}
              author={t("Home__TestimonialFour--Author")}
              role={t("Home__TestimonialFour--Role")}
            />
            <div className="se:-mb-6 se:-ml-2/12 laptop:-mr-4.5% py-3.5 w-130% tablet:w-90 tablet:mx-auto laptop:w-7/12">
              <Img fluid={data.multiplyOutreach.childImageSharp.fluid} alt="multiply outreach" />
            </div>
          </div>
          <div className="w-full flex flex-col laptop:flex-row justify-between">
            {/* Fifth WhatIsSocialie Section with Image */}
            <div className="pt-3.5 se:-mb-1 w-120% se:-ml-1/12 laptop:-ml-4.5% tablet:mx-auto tablet:w-90 laptop:-mb-1/12 laptop:w-7/12">
              <Img fluid={data.socialDream.childImageSharp.fluid} alt="social dream" />
            </div>
            <Frame
              subheading={t("Home__WhatIsSocialie--SectionFive-Subheading")}
              heading={t("Home__WhatIsSocialie--SectionFive-Heading")}
              desc={t("Home__WhatIsSocialie--SectionFive-Desc")}
              quote={t("Home__TestimonialFive--Quote")}
              logoSrc={data.ufc.childImageSharp.fluid}
              author={t("Home__TestimonialFive--Author")}
              role={t("Home__TestimonialFive--Role")}
            />
          </div>
        </div>
      </div>
    </>
  )
}

interface Props {
  heading: string
  subheading: string
  desc: string
  quote?: string
  author: string
  logoSrc?: FluidObject
  role: string
}

function Frame(props: Props) {
  const { subheading, heading, desc, quote, logoSrc, author, role } = props
  return (
    <div className="w-full laptop:w-5/12">
      <div className="mb-6 flex justify-center">
        <div>
          <div className="mb-1.5">
            <h5 className="text-h6 text-darkGrey leading-h5 tracking-12 font-black">{subheading}</h5>
          </div>
          <div className="mb-1.5">
            <h3 className="font-serif text-h4 leading-h4 text-body tracking-11">{heading}</h3>
          </div>
          <div className="mb-4">
            <p className="text-body text-p tracking-10 leading-h6">{desc}</p>
          </div>
          <Testimonial logoSrc={logoSrc} quote={quote} author={author} role={role} />
        </div>
      </div>
    </div>
  )
}
